// client/src/components/auth/profile/FloatingSelect.js
import React, { useState } from 'react'
import './FloatingComponents.css'

function FloatingSelect({
  label,
  name,
  value,
  onChange,
  options,
  required = false,
  disabled = false,
  onDisabledClick,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false)
  const hasValue = value && value.length > 0
  const isActive = isFocused || hasValue

  return (
    <div
      className={`floating-input-container ${
        disabled ? 'clickable-when-disabled' : ''
      }`}
      onClick={
        disabled && onDisabledClick
          ? (e) => {
              onDisabledClick(e)
            }
          : undefined
      }
      style={disabled ? { cursor: 'pointer' } : {}}
    >
      <select
        className={`floating-select ${
          required && !hasValue ? 'has-error' : ''
        }`}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
        style={disabled ? { pointerEvents: 'none' } : {}}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <label
        className={`floating-label ${isActive ? 'active' : ''} ${
          required ? 'required' : ''
        }`}
        style={disabled ? { pointerEvents: 'none' } : {}}
      >
        {label}
      </label>
    </div>
  )
}

export default FloatingSelect
